import AbacusClientUtils from '@homeaway/abacus-client-utils';
import {HA_PULSE_AA_TEST} from '../abacus/experiments';

const tests = (typeof window !== 'undefined' ? window.__ABACUS__ : {});

export const initialize = () => {
    if (window !== 'undefined') {
        // set up abacus experiment cache
        AbacusClientUtils.initialize(tests);
        AbacusClientUtils.evaluateExperimentAndLog(HA_PULSE_AA_TEST);
    }
};

export const isTestOn = (abacus = {}, testName) => {
    return abacus[testName] && abacus[testName].value > 0 || false;
};

export default {initialize};



// WEBPACK FOOTER //
// ./src/universal/utils/abacus.js